import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  RankingCategoryItem,
  ViewDataService,
  WCupSeasonItem
} from 'world-archery-lib';
import { BaseFiltersComponent } from '../../shared/base-filters.component';
import { FiltersSeriesEliteRankingService } from '../filters-series-elite-ranking.service';

@Component({
  selector: 'app-filters-elite-ranking',
  templateUrl: './filters-elite-ranking.component.html',
  styleUrls: ['./filters-elite-ranking.component.css']
})
export class FiltersEliteRankingComponent {
  constructor(
    protected views: ViewDataService,
    public filter_service: FiltersSeriesEliteRankingService
  ) {
  }
}
